/**
 * @generated SignedSource<<ae7b4939fdea464930e0f014fce7c3a3>>
 * @relayHash 5ebf1285eea0f6e277ccc1791c349170
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 83f26dc21ea579fed2d0d4ec2f290a108314a7d06a83cc5b9fbf80b01a76c7b9

import type { ConcreteRequest } from 'relay-runtime';
export type preloadIncomingLinksSampleQuery$variables = {
  cypherQuery: string;
  first: number;
};
export type preloadIncomingLinksSampleQuery$data = {
  readonly graphStore_cypherQueryV2: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly columns: ReadonlyArray<{
          readonly key: string;
          readonly value: {
            readonly __typename: "GraphStoreCypherQueryV2AriNode";
            readonly id: string;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          } | null;
        }>;
      };
    }>;
  } | null;
};
export type preloadIncomingLinksSampleQuery = {
  response: preloadIncomingLinksSampleQuery$data;
  variables: preloadIncomingLinksSampleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cypherQuery"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "query",
        "variableName": "cypherQuery"
      }
    ],
    "concreteType": "GraphStoreCypherQueryV2Connection",
    "kind": "LinkedField",
    "name": "graphStore_cypherQueryV2",
    "plural": false,
    "selections": [
      {
        "concreteType": "GraphStoreCypherQueryV2Edge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "GraphStoreCypherQueryV2Node",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreCypherQueryV2Column",
                "kind": "LinkedField",
                "name": "columns",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  {
                    "kind": "LinkedField",
                    "name": "value",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          }
                        ],
                        "type": "GraphStoreCypherQueryV2AriNode"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "preloadIncomingLinksSampleQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "preloadIncomingLinksSampleQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5ebf1285eea0f6e277ccc1791c349170",
    "id": "83f26dc21ea579fed2d0d4ec2f290a108314a7d06a83cc5b9fbf80b01a76c7b9",
    "metadata": {},
    "name": "preloadIncomingLinksSampleQuery",
    "operationKind": "query",
    "text": "query preloadIncomingLinksSampleQuery($cypherQuery:String!,$first:Int!){graphStore_cypherQueryV2(query:$cypherQuery,first:$first)@optIn(to:\"GraphStoreCypherQueryV2\"){edges{node{columns{key,value{__typename,...on GraphStoreCypherQueryV2AriNode{id}}}}}}}"
  }
};
})();

(node as any).hash = "60d2b49af10374001914afa2e5cda7a3";

export default node;
